module.exports = __webpack_public_path__ + "img/symbol_17_normal.277aa306.png";